import { GlobalVariables } from "./data";
import { Params } from "./data-structures";

declare var departments: any;
declare var agencies: any;
declare var series: any;
declare var cyberWorkRoles: any;
declare var cyberWorkGroupings: any;
declare var searchFilters: any;
declare var brandedSearch: Params;
declare var payPlans: any;

export namespace DataConversion {
    var StaticData = {}
    StaticData["Department"] = departments;
    StaticData["Agency"] = agencies;
    StaticData["Series"] = series;
    StaticData["CyberWorkRoles"] = cyberWorkRoles;
    StaticData["CyberWorkGroupings"] = cyberWorkGroupings;
    StaticData["SearchFilters"] = searchFilters;
    StaticData["PayPlans"] = payPlans;
    var Parameters: Params;

    export function convertData(data: any) {
        Parameters = GlobalVariables.getParams();
        data.filterData = {};
        data.filterData["Department"] = convertOrganizations(data.f["d"], "Department");
        data.filterData["Agency"] = convertOrganizations(data.f["a"], "Agency");
        data.filterData["Series"] = convertSeries(data.f["j"]);

        for (var i = 0; i < StaticData["SearchFilters"].length; i++) {
            var aliasMapping = GlobalVariables.getAliasMapping();
            var filterType = StaticData["SearchFilters"][i].FilterType
            if (!StaticData["SearchFilters"][i].Partial) {
                data.filterData[filterType] = populateCounts(StaticData["SearchFilters"][i], data.f[aliasMapping[filterType].Abbreviation]);
            }
        }

        return data;
    }

    export function getSearchFilters(): SearchFilter[] {
        return StaticData["SearchFilters"];
    }

    function populateCounts(searchFilter: SearchFilter, codeCounts: Map<string, number>) {
        var aliasMapping = GlobalVariables.getAliasMapping();
        var selectedOptions = {};
        for (var i = 0; i < Parameters[aliasMapping[searchFilter.FilterType].JOAQueryName].length; i++) {
            selectedOptions[Parameters[aliasMapping[searchFilter.FilterType].JOAQueryName][i]] = "";
        }
        var brandedSearchValue = brandedSearch ? brandedSearch[aliasMapping[searchFilter.FilterType].JOAQueryName] : null;
        if (searchFilter.FilterGroup) {
            for (var i = 0; i < searchFilter.FilterGroup.length; i++) {
                var group = searchFilter.FilterGroup[i];
                group.Count = 0;
                for (var j = 0; j < searchFilter.FilterGroup[i].Items.length; j++) {
                    var item = searchFilter.FilterGroup[i].Items[j];
                    item.Selected = selectedOptions.hasOwnProperty(item.Value);
                    if (brandedSearch && brandedSearchValue) {
                        if (brandedSearchValue.includes(item.Value) || brandedSearchValue.includes("" + item.Value + "")) {
                            item.AlwaysShow = true;
                            group.AlwaysShow = true;
                            item.Count = codeCounts && codeCounts.hasOwnProperty(item.Value) ? codeCounts[item.Value] : 0;
                            item.Selected = selectedOptions.hasOwnProperty(item.Value);
                            item.IsDisabled = true;
                            group.Count += item.Count;
                        }
                    }
                    else {
                        item.Count = codeCounts && codeCounts.hasOwnProperty(item.Value) ? codeCounts[item.Value] : 0;
                        item.Selected = selectedOptions.hasOwnProperty(item.Value);
                        group.Count += item.Count;
                    }
                }
            }
        } else {
            for (var i = 0; i < searchFilter.Items.length; i++) {
                var item = searchFilter.Items[i];
                if (brandedSearch && brandedSearchValue) {
                    var brandedSearchValue = brandedSearch[aliasMapping[searchFilter.FilterType].JOAQueryName];
                    if (brandedSearchValue && (brandedSearchValue.includes(item.Value) || brandedSearchValue.includes("" + item.Value + ""))) {
                        item.AlwaysShow = true;
                        item.Count = codeCounts && codeCounts.hasOwnProperty(item.Value) ? codeCounts[item.Value] : 0;
                        item.Selected = selectedOptions.hasOwnProperty(item.Value);
                        item.IsDisabled = true;
                    }
                }
                else {
                    item.Count = codeCounts && codeCounts.hasOwnProperty(item.Value) ? codeCounts[item.Value] : 0;
                    item.Selected = selectedOptions.hasOwnProperty(item.Value);
                }
            }
        }

        return searchFilter;
    }

    export function getSeriesByFamily(familyCode: string) {
        return StaticData["Series"][familyCode];
    }

    export function getCyberWorkRoleByCode(code: string) {
        return StaticData["CyberWorkRoles"][code];
    }

    export function getPayPlanByJobGradeCode(code: string) {
        let payPlan = StaticData["PayPlans"][code.toUpperCase()];
        return payPlan === undefined || payPlan == null ? null : `${code.toUpperCase()} (Pay Plan)`;
    }

    export function getCyberWorkGroupingByCode(code: string) {
        return StaticData["CyberWorkGroupings"][code];
    }

    function convertOrganizations(organizations: any, type: string) {
        var filterGroupings = {}
        var selectedOrganizations = {};

        for (var i = 0; i < Parameters[type].length; i++) {
            selectedOrganizations[Parameters[type][i]] = "";
        }

        for (var code in StaticData[type]) {
            var curOrganization: Organization = StaticData[type][code];
            var filterItem: FilterItem = new FilterItem();
            filterItem.Name = curOrganization.Name;
            filterItem.Value = code;
            filterItem.Selected = hasOwnPropertyIC(selectedOrganizations, code);
            filterItem.Count = hasOwnPropertyIC(organizations, code) ? organizations[code] : 0;

            if (curOrganization.Sort == "" || curOrganization.Sort == null) {
                curOrganization.Sort = curOrganization.Name.toLowerCase().replace("department of ", "");
            }

            var firstChar = curOrganization.Sort.charAt(0).toUpperCase();
            if (filterGroupings.hasOwnProperty(firstChar)) {
                filterGroupings[firstChar].Items.push(filterItem);
                if (filterGroupings[firstChar].ShowGroup === false) {
                    filterGroupings[firstChar].ShowGroup = filterItem.Count > 0 ? true : false;
                }
            } else {
                var filterGroup: FilterGroup = new FilterGroup()
                filterGroup.Group = firstChar;
                filterGroup.Items = [filterItem];
                filterGroup.ShowGroup = filterItem.Count > 0 ? true : false;
                filterGroupings[firstChar] = filterGroup;
            }
        }

        var filterGroupArray:any[] = [];
        for (var key in filterGroupings) {
            filterGroupArray.push(filterGroupings[key]);
        }

        return filterGroupArray;
    }

    function convertSeries(Series: any) {
        var selectedSeries = {};
        var filterGroupings = {};
        var seriesKeys:string[] = [];
        var brandedSearchValue: string[] | null = (!brandedSearch) ? null : brandedSearch["JobCategoryCode"] || null;

        for (var i = 0; i < Parameters.JobCategoryCode.length; i++) {
            selectedSeries[Parameters.JobCategoryCode[i]] = "";
        }

        for (var code in StaticData["Series"]) {
            var filterGroup: FilterGroup = new FilterGroup();
            filterGroup.Group = StaticData["Series"][code].Name
            filterGroup.Code = code;
            filterGroup.Items = [];
            filterGroup.ShowGroup = false;

            for (var subCode in StaticData["Series"][code].Children) {
                var filterItem: FilterItem = new FilterItem();
                filterItem.Name = StaticData["Series"][code].Children[subCode].Name;

                if (brandedSearchValue === null) {
                    filterItem.Count = Series && Series.hasOwnProperty(subCode) ? Series[subCode] : 0;
                    filterItem.Selected = selectedSeries.hasOwnProperty(subCode);
                } else if (brandedSearchValue && (brandedSearchValue.indexOf(subCode) !== -1 || brandedSearchValue.indexOf("" + subCode + "") !== -1)) {
                    filterItem.Count = Series && Series.hasOwnProperty(subCode) ? Series[subCode] : 0;
                    filterItem.Selected = selectedSeries.hasOwnProperty(subCode);
                    filterItem.IsDisabled = true
                    filterItem.AlwaysShow = true;
                    filterGroup.AlwaysShow = true;
                }

                filterItem.Value = subCode;

                if (filterItem.Count > 0) {
                    filterGroup.ShowGroup = true;
                }

                filterGroup.Items.push(filterItem);
            }

            filterGroupings[code] = filterGroup;
            seriesKeys.push(code);
        }
        seriesKeys.sort();
        var filterGroupArray:any[] = [];
        for (var i = 0; i < seriesKeys.length; i++) {
            filterGroupArray.push(filterGroupings[seriesKeys[i]]);
        }

        return filterGroupArray;
    }

    function hasOwnPropertyIC(obj, property) {
        var props:any[] = [];
        for (var i in obj) if (obj.hasOwnProperty(i)) props.push(i);
        var prop;
        while (prop = props.pop()) if (prop.toLowerCase() === property.toLowerCase()) return true;
        return false;
    }

    export interface SearchFilter {
        FilterType: string;
        Partial: string;
        FilterGroup: FilterGroup[];
        Items: FilterItem[];
    }

    export class FilterGroup {
        Group: string = "";
        Code: string = "";
        Count: number = 0;
        ShowGroup: boolean = false;
        AlwaysShow: boolean = false;
        Items: FilterItem[] = [];
    }

    export class FilterItem {
        Name: string = "";
        Value: string = "";
        Count: number = 0;
        Selected: boolean = false;
        IsGroup: boolean = false;
        Tooltip: string = "";
        AlwaysShow: boolean = false;
        IsDisabled: boolean = false;
    }

    class Organization {
        Name: string = "";
        Sort: string = "";
    }
}
